export const USER_QUERY_KEYS = {
  default: () => ['user'] as const,
  getCookieUser: () => [...USER_QUERY_KEYS.default(), 'getCookieUser'] as const,
  updateUser: () => [...USER_QUERY_KEYS.default(), 'updateUser'] as const,
  getUser: () => [...USER_QUERY_KEYS.default(), 'getUser'] as const,
};
